import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";

import MatchDots from '../../components/ExcerciseTypes/LineTo/MatchDots';
import DesignUnderLine2 from "../../components/ExcerciseTypes/Design/DesignUnderLine2";
const json = {
 
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    autoPlay : true,
    video: "",
    // recorder: true,
    // exerciseKey: "/img/FriendsPlus/Page4/Key/E1answerKey.jpg",
    component: T6,
    isHiddenCheck:true,
	hideBtnFooter:true,
    stylesTextInput: { },
    inputSize:500,
    titleQuestion: [
      {
        num: "",
        title: `
			<img src='/img/FriendsPlus/Page2/a.jpg' style='height:15mm;margin-right:20px' /> Sắm vai một loài hoa, em hãy giới thiệu về mình với các bạn.
		
		`,
        color: "rgb(3, 103, 181)",
      },
    ],
   
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
			
       
          
        `,
        answer: [],
      },
    ],
    
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    autoPlay : true,
    video: "",
    // recorder: true,
    // exerciseKey: "/img/FriendsPlus/Page4/Key/E1answerKey.jpg",
    component: T6,
    isHiddenCheck:true,
	hideBtnFooter:true,
    stylesTextInput: { },
    inputSize:500,
    titleQuestion: [
      {
        num: "",
        title: `
			<img src='/img/FriendsPlus/Page2/E2/1.jpg' style='height:15mm;margin-right:50px' /> <span style='text-align:center;font-weight:bold;color:#5d4c80'>CÔNG CHÚA VÀ NGƯỜI DẪN CHUYỆN</span>
      
		`,
        color: "rgb(3, 103, 181)",
      },
    ],
   
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
			<div style='width:25cm'>
				&emsp;Sau bữa ăn trưa, cô giáo thông báo Giét-xi được chọn đóng vai công chúa trong vở kịch sắp tới. Cảm nhận được
        ánh mắt ngưỡng mộ của bạn bè, Giét-xi vui lắm.<br>
        &emsp;Về nhà, Giét-xi hào hứng kể cho mẹ nghe. Cả tuần ấy, tối nào mẹ cũng tập lời thoại cùng Giét-xi. Giét-xi  chăm chỉ 
        luyện tập và nhớ lời thoại rất nhanh. Nhưng khi lên sân khấu diễn thử, mọi lời thoại trong đầu Giét-xi đều bay đi đâu hết. 
        Cuối cùng, cô giáo đành nói:<br>
        &emsp;- Giét-xi à, cô đã bổ sung vai dẫn chuyện cho vở kịch. Cô nghĩ vai đó hợp với em hơn. Em có đồng ý đổi vai không? <br>
        &emsp;Lời nói cô rất dịu dàng nhưng Giét-xi thấy buồn lắm. Sao không buồn khi phải nhường vai chính cho bạn!<br>
        &emsp;Thấy Giét-xi buồn, mẹ thủ thỉ:<br>
        &emsp;- Hôm nay mẹ con mình cùng nhau nhổ vườn cỏ nhé.<br>
        &emsp;Khu vườn vào xuân, những cây hồng leo khóa tấm áo xanh mới.<br>
        &emsp;- Mẹ con mình sẽ nhổ hết cỏ và hoa dại ở đây. Từ giờ vườn nhà ta chỉ có hoa hồng thôi. - Vừa nói, mẹ vừa chạm tay vào khóm bồ công anh.<br>
        &emsp;- Đừng, mẹ! Con thích hoa bồ công anh. Loài hoa nào cũng đẹp cả, kể cả bồ công anh. - Giét-xi nói.<br>
        &emsp;Mẹ mỉm cười:<br>
        &emsp;- Đúng rồi, mỗi loài hoa đều có một vẻ đẹp riêng con ạ. Con người cũng vậy, không phải ai cũng thành công chúa, nhưng điều đó không có gì đáng xấu hổ.<br>
        &emsp;Giét-xi đoán mẹ đã biết chuyện thay vai diễn của mình.<br>
        &emsp;Mẹ dịu dàng nói.<br>
        &emsp;- Con gái bé nhỏ của mẹ, con có giọng đọc truyền cảm, rất hợp với vai người dẫn chuyện. Nếu thiếu người dẫn chuyện, vở kịch cũng khó mà thành công được con ạ.<br>

				<div style='text-align: end'>(Du-nan biên soạn, Hòa Vân dịch)</div>
			</div>
       
          
        `,
        answer: [],
      },
    ],
    
  },
  
};

export default json;
